import "./CompanyInformationViewComponent.scss";
import template from "./CompanyInformationViewComponent.html";
import {IComponentOptions} from "angular";
import {Ng1Controller, TargetState, Transition} from "@uirouter/angularjs";
import {StateService} from "@uirouter/core";
import {CodeAndExchange, decodeSecurity, encodeSecurity} from "../../instruments/types/CodeAndExchange";
import {GTMConversionEventService} from "../../analytics/services/GTMConversionEventService";

export const CompanyInfoView = "tfCompanyInformationView";

export function companyInfoView(): IComponentOptions {
    return {
        template,
        controllerAs: "ctrl",
        controller: CompanyInformationViewComponentController
    };
}

interface StateParameters {
    security: string | null;
    view: ViewTypes | null;
}

type ViewTypes = "overview" | "fundamentals" | "dividends" | "news" | "directors" | "historical";

export class CompanyInformationViewComponentController implements Ng1Controller {

    public security: CodeAndExchange;
    public activeView: ViewTypes;

    /** @ngInject */
    public constructor(private readonly $stateParams: StateParameters,
                       private readonly $state: StateService,
                       private readonly gtmConversionEventService: GTMConversionEventService) {
        this.activeView = this.$stateParams.view || "overview";
        if (this.$stateParams.security != null) {
            this.security = decodeSecurity(this.$stateParams.security);
        }
    }

    public $onInit() {
        this.gtmConversionEventService.sendPageView(
            {
                path: "company-info",
                hostUrl: window.location.host,
                title: "Company Info"
            }
        );
    }

    public uiOnParamsChanged(stateParameters: StateParameters, $transition$: Transition) {
        if (stateParameters.view != null) {
            this.activeView = stateParameters.view;
        }
        if (stateParameters.security != null) {
            this.security = decodeSecurity(stateParameters.security);
        }
    }

    public securityChanged(security: CodeAndExchange) {
        const encoded = encodeSecurity(security);
        this.$state.go("company-info", {view: this.activeView, security: encoded});
    }

    public uiCanExit(transition: Transition): boolean | TargetState | void | Promise<boolean | TargetState | void> {
        return true;
    }
}
